const ObservationsPreviewModal = (options = {}) => {
  const _defaults = {
    triggersSelector: '.js-media-modal-trigger',
    modalSelector: '.c-observationsEdit__previewModal',
    modalContentSelector: '.c-observationsEdit__previewModalContent',
    modalCloseSelector: '.js-modal-close',
  };

  const _settings = { ..._defaults, ...options };

  let triggers, modal, modalContent, modalClose;

  const onTriggerClick = function (event) {
    const trigger = event.currentTarget;
    const attachmentUrl = trigger.dataset.attachmentUrl;
    const attachmentType = trigger.dataset.attachmentType;

    modalContent.innerHTML = '';

    if (attachmentType.startsWith('image')) {
      const container = document.createElement('div');
      container.style.position = 'relative';

      const img = document.createElement('img');
      img.src = attachmentUrl;
      img.alt = 'Full-size observation image';
      container.appendChild(img);

      if (trigger.dataset.focalX && trigger.dataset.focalY) {
        const focalX = parseFloat(trigger.dataset.focalX).toFixed(2);
        const focalY = parseFloat(trigger.dataset.focalY).toFixed(2);

        const marker = document.createElement('div');
        marker.className = 'c-observationsEdit__focalPoint';
        marker.style.left = `calc(${focalX}% - 1rem)`;
        marker.style.top = `calc(${focalY}% - 1rem)`;

        container.appendChild(marker);
      }

      modalContent.appendChild(container);
    } else if (attachmentType.startsWith('video')) {
      const video = document.createElement('video');
      video.controls = true;

      const source = document.createElement('source');
      source.src = attachmentUrl;
      source.type = attachmentType;
      video.appendChild(source);
      modalContent.appendChild(video);
    }

    modal.style.display = 'flex';
    modal.style.flexDirection = 'column';
    modal.style.justifyContent = 'center';
    modal.style.alignItems = 'center';
  };

  const onModalCloseClick = function () {
    modal.style.display = 'none';
    modalContent.innerHTML = '';
  };

  const onWindowClick = function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
      modalContent.innerHTML = '';
    }
  };

  // Public: Initialise module
  const init = () => {
    triggers = document.querySelectorAll(_settings.triggersSelector);
    modal = document.querySelector(_settings.modalSelector);
    modalContent = document.querySelector(_settings.modalContentSelector);
    modalClose = document.querySelector(_settings.modalCloseSelector);

    if (!modal || !modalContent || !modalClose) {
      return;
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', onTriggerClick);
    });

    modalClose.addEventListener('click', onModalCloseClick);
    window.addEventListener('click', onWindowClick);
  };

  // Public: Remove event listeners
  const destroy = () => {
    if (triggers) {
      triggers.forEach((trigger) => {
        trigger.removeEventListener('click', onTriggerClick);
      });
    }
    if (modalClose) {
      modalClose.removeEventListener('click', onModalCloseClick);
    }
    window.removeEventListener('click', onWindowClick);
  };

  // Public: Reinitialize the module (destroy then init)
  const reinit = () => {
    destroy();
    init();
  };

  return {
    init,
    destroy,
    reinit,
  };
};

export default ObservationsPreviewModal;
